"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var maskAutoCompleteRecipientOperation_1 = require("owa-service/lib/operation/maskAutoCompleteRecipientOperation");
var maskAutoCompleteRecipientRequest_1 = require("owa-service/lib/factory/maskAutoCompleteRecipientRequest");
function configureRequestBody(emailAddress) {
    return maskAutoCompleteRecipientRequest_1.default({
        EmailAddress: emailAddress,
    });
}
function maskAutoCompleteRecipient(emailAddress) {
    var requestBody = configureRequestBody(emailAddress);
    return maskAutoCompleteRecipientOperation_1.default(requestBody).then(function (response) {
        var responseMessage = response;
        return responseMessage;
    });
}
exports.maskAutoCompleteRecipient = maskAutoCompleteRecipient;
//# sourceMappingURL=maskAutoCompleteRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/services/maskAutoCompleteRecipient.js
// module id = 3390
// module chunks = 2 3